import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import { useState } from 'react'

import './Login.scss'

const LoginBtn = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(false);

  const pathname = location.pathname
  return (
    <div className='dynamicbtn'>
      <Button className={pathname === '/login' ? 'active' : ''
      } onClick={() => navigate('/login')}>
        Sign in
      </Button>
      <Button className={pathname === '/register' ? 'active' : ''
      } onClick={() => navigate('/register')}>
        Sign up
      </Button>

    </div>
  )
}

export default LoginBtn